import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import MapInformationPage from './MapInformationPage/MapInformationPage';

const MapInformationFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <MapInformationPage />
        </AuthCheck>
      </Route>
    </Switch>
  );
};

export default MapInformationFeature;
